import { Outlet, useLocation } from "react-router-dom";
import { SurveilLogo } from '@/components/SurveilLogo';
import { LoginArea } from '@/components/auth/LoginArea';
import { ScryfallStatusBanner } from '@/components/ScryfallStatusBanner';


import { ThemeToggle } from '@/components/ThemeToggle';
import { Link } from 'react-router-dom';

export function Layout() {
  const location = useLocation();
  const isBuildPage = location.pathname === '/build';

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Mobile Header */}
      <header className="sm:hidden border-b border-border/40 bg-background/80 backdrop-blur-xl sticky top-0 z-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-3 items-center h-12">
            <div className="flex items-center justify-start">
              {/* This space can be used for a left-aligned element if needed in the future */}
            </div>
            <div className="flex items-center justify-center">
              <Link to="/" className="flex items-center gap-2">
                <div className="w-6 h-6">
                  <SurveilLogo />
                </div>
                <div>
                  <h1 className="text-lg font-bold bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text text-transparent">
                    Surveil
                  </h1>
                </div>
              </Link>
            </div>
            <div className="flex items-center justify-end gap-2">
              <div className="hidden sm:block">
                <ThemeToggle />
              </div>
              <LoginArea />
            </div>
          </div>
        </div>
      </header>

      {/* Desktop Header */}
      <header className="hidden sm:block border-b border-border/40 bg-background/80 backdrop-blur-xl sticky top-0 z-50">
        <div className="container mx-auto px-4 py-2">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <div className="w-8 h-8">
                <SurveilLogo />
              </div>
              <div>
                <h1 className="text-xl font-bold bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text text-transparent">
                  Surveil
                </h1>
                <p className="text-xs text-muted-foreground">Magic: The Gathering on Nostr</p>
              </div>
            </Link>
            <div className="flex items-center gap-3">
              <ThemeToggle />
              <LoginArea />
            </div>
          </div>
        </div>
      </header>

      <ScryfallStatusBanner />

      <Outlet />

      {!isBuildPage && (
        <footer className="mt-auto py-4 px-6 text-center text-sm text-muted-foreground">
          <a
            href="https://gitlab.com/chad.curtis/surveil"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Source Code
          </a>
          <span className="mx-2">&bull;</span>
          <span>Vibed with <a href="https://soapbox.pub/mkstack" target="_blank" rel="noopener noreferrer" className="hover:underline">MKStack</a></span>
        </footer>
      )}
    </div>
  );
}
